import * as helper from "../utils/helper"
import * as aes from "../utils/aes"
import * as request from "../utils/request"
import QRCode from "qrcode"
import * as url from "../utils/url"
import * as ua from "../utils/ua"
import html2canvas from "../libs/html2canvas"
import * as md5 from "../libs/md5"

export function mobileSubscribe(params, extendParams) {
  return new Promise((resolve, reject) => {
    let env = helper.getCgiEnv(params.sandbox)
    let data = {
      from_https: 1,
      from_h5: 1,
      pf: "mds_wechat_gmshop-pay_html5-html5",
      pfkey: "pfkey",
      t: +new Date()
    }
    data = Object.assign(data, extendParams, aes.encrypt(data, ["openid", "openkey", "session_id", "session_type"], params.sandbox))

    request
      .ajax({
        url: `//${env}api.unipay.qq.com/v1/r/${params.offerId}/mobile_subscribe`,
        data: data
      })
      .then(res => {
        if (res.ret == 0) {
          resolve(res)
        } else {
          reject(res)
        }
      })
      .catch(reject)
  })
}

export function luckDrawProc(params, extendParams) {
  return new Promise((resolve, reject) => {
    let env = helper.getCgiEnv(params.sandbox)
    let data = {
      from_https: 1,
      from_h5: 1,
      pf: "mds_wechat_gmshop-pay_html5-html5",
      pfkey: "pfkey",
      t: +new Date()
    }
    data = Object.assign(data, extendParams, aes.encrypt(data, ["openid", "openkey", "session_id", "session_type"], params.sandbox))

    request
      .ajax({
        url: `//${env}api.unipay.qq.com/v1/r/${params.offerId}/luckdraw_proc`,
        data: data
      })
      .then(res => {
        if (res.ret == 0) {
          resolve(res)
        } else {
          reject(res)
        }
      })
      .catch(reject)
  })
}

export function wechatQuery(params, extendParams) {
  return new Promise((resolve, reject) => {
    let env = helper.getCgiEnv(params.sandbox)
    let data = {
      from_https: 1,
      from_h5: 1,
      pf: "mds_wechat_gmshop-pay_html5-html5",
      pfkey: "pfkey",
      t: +new Date()
    }
    data = Object.assign(data, extendParams, aes.encrypt(data, ["openid", "openkey", "session_id", "session_type"], params.sandbox))

    request
      .ajax({
        url: `//${env}api.unipay.qq.com/v1/r/${params.offerId}/wechat_query`,
        data: data
      })
      .then(res => {
        if (res.ret == 0) {
          resolve(res)
        } else {
          reject(res)
        }
      })
      .catch(reject)
  })
}

export function followActivity(params, extendParams) {
  return new Promise((resolve, reject) => {
    let env = helper.getCgiEnv(params.sandbox)
    let data = {
      from_https: 1,
      from_h5: 1,
      pf: "mds_wechat_gmshop-pay_html5-html5",
      pfkey: "pfkey",
      t: +new Date()
    }
    data = Object.assign(data, extendParams, aes.encrypt(data, ["openid", "openkey", "session_id", "session_type"], params.sandbox))

    request
      .ajax({
        url: `//${env}api.unipay.qq.com/v1/r/${params.offerId}/follow_activity`,
        data: data
      })
      .then(res => {
        if (res.ret == 0) {
          resolve(res)
        } else {
          reject(res)
        }
      })
      .catch(reject)
  })
}

export function getMobileZones(params) {
  return new Promise((resolve, reject) => {
    let env = helper.getCgiEnv(params.sandbox)
    let urlParams = {
      from_https: 1,
      from_h5: 1,
      pf: `mds_wechat_qb-pay_html5-${params.clientVersion}`,
      pfkey: "pfkey",
      cmd: 14,
      openid: params.openid,
      openkey: params.openkey,
      session_id: params.sessionId,
      session_type: params.sessionType,
      wx_appid: params.wxAppid2,
      use_currency_offerid: 1
    }

    request
      .ajax({
        url: `//${env}api.unipay.qq.com/v1/r/${params.offerId}/wechat_query`,
        data: urlParams
      })
      .then(res => {
        if (res.ret == 0) {
          resolve(res)
        } else {
          reject(res)
        }
      })
      .catch(reject)
  })
}

export function getMobileRoleInfo(params) {
  return new Promise((resolve, reject) => {
    let env = helper.getCgiEnv(params.sandbox)
    let urlParams = {
      from_https: 1,
      from_h5: 1,
      pf: `mds_wechat_qb-pay_html5-${params.clientVersion}`,
      pfkey: "pfkey",
      cmd: 15,
      openid: params.openid,
      openkey: params.openkey,
      session_id: params.sessionId,
      session_type: params.sessionType,
      wx_appid: params.wxAppid2,
      zoneid: params.zoneid,
      use_currency_offerid: 1
    }

    let cgiName = "wechat_query"
    if (params.useCmallQuery) {
      cgiName = "cmall_query"
    }
    request
      .ajax({
        url: `//${env}api.unipay.qq.com/v1/r/${params.offerId}/${cgiName}`,
        data: urlParams
      })
      .then(res => {
        if (res.ret == 0) {
          resolve(res)
        } else {
          reject(res)
        }
      })
      .catch(reject)
  })
}

export function getRoleInfo(params) {
  return new Promise((resolve, reject) => {
    let env = helper.getCgiEnv(params.sandbox)
    let urlParams = {
      from_https: 1,
      from_h5: 1,
      pf: `mds_wechat_qb-pay_html5-${params.clientVersion}`,
      pfkey: "pfkey",
      cmd: 15,
      openid: params.openid,
      openkey: params.openkey,
      session_id: params.sessionId,
      session_type: params.sessionType,
      wx_appid: params.wxAppid2,
      partition: params.zoneid,
      game_platform_id: params.platformId,
      area: params.area
    }

    request
      .ajax({
        url: `//${env}api.unipay.qq.com/v1/r/${params.offerId}/wechat_query`,
        data: urlParams
      })
      .then(res => {
        if (res.ret == 0) {
          resolve(res)
        } else {
          reject(res)
        }
      })
      .catch(reject)
  })
}

export function getPCGameRoleInfo(params, extendParams = {}) {
  return new Promise((resolve, reject) => {
    // 如果是DNF端游，查角色使用1450017593，因为DNF充值点券是不需要查角色的，1450000238无需配置查角色，如果加上可能会影响其他场景。
    const offerId = params.offerId == "1450000238" ? "1450017593" : params.offerId
    let urlParams = {
      from_https: 1,
      from_h5: 1,
      pf: "mds_wechat_qb-pay_html5-html5",
      pfkey: "pfkey",
      openid: params.openid,
      openkey: params.openkey,
      session_id: params.sessionId,
      session_type: params.sessionType,
      wx_appid: params.wxAppid2 || "",
      qq_appid: params.qqAppid || "",
      sck: md5.hex_md5(offerId + params.openkey),
      game_info_mode: 1,
      change_wx_openid: 1,
      zoneid: params.zoneid,
      isusempaymode: 1,
      game_scene: "dq_pay",
      t: +new Date()
    }

    urlParams = helper.extend(urlParams, extendParams)
    request
      .ajax({
        url: `//api.unipay.qq.com/v1/r/${offerId}/get_role_list`,
        data: urlParams
      })
      .then(res => {
        if (res.ret == 0) {
          resolve(res)
        } else {
          reject(res)
        }
      })
  })
}

export function getUserRecommend(params, extendParams = {}) {
  return new Promise((resolve, reject) => {
    let env = helper.getCgiEnv(params.sandbox)
    let urlParams = {
      from_https: 1,
      from_h5: 1,
      pf: "mds_wechat_qb-pay_html5-html5",
      pfkey: "pfkey",
      cmd: 26,
      openid: params.openid,
      openkey: params.openkey,
      session_id: params.sessionId,
      session_type: params.sessionType,
      wx_appid: params.wxAppid2,
      model: params.model,
      ext: `usr_appid=${params.ext}`
    }
    let data = Object.assign(urlParams, extendParams)
    request
      .ajax({
        url: `//${env}api.unipay.qq.com/v1/r/${params.offerId}/wechat_query`,
        data: data
      })
      .then(res => {
        if (res.ret == 0) {
          resolve(res)
        } else {
          reject(res)
        }
      })
      .catch(reject)
  })
}

export function generateQRCode({ url, success }) {
  QRCode.toDataURL(
    url,
    {
      margin: 1
    },
    function(err, dataUrl) {
      if (!err) {
        // 证明生成了二维码（canvas） 然后把二维码转为图片
        success(dataUrl)
      }
    }
  )
}

/**
 * 分享部分
 */

export function shareMessageInQQ(params) {
  initMqq().then(() => {
    let data = {
      share_type: params.type || 0,
      title: params.title,
      desc: params.desc,
      share_url:
        params.url || `${location.origin}${location.pathname}${url.delParam("pf", location.search)}&pf=${params.pf}${location.hash}`,
      image_url: params.img,
      back: true
    }
    if (mqq.compare("5.4") != 0) {
      //5.4不能增加公众号显示，会导致程序crash
      data.puin = "3042703080"
      data.sourceName = "腾讯充值"
    }
    mqq.ui.shareMessage(data, result => {
      params.reportCallback && params.reportCallback(result)
    })
  })
}

export function showShareMenu() {
  initMqq().then(() => {
    mqq.ui.showShareMenu()
  })
}

function initMqq() {
  return request.getScript("//pub.idqqimg.com/qqmobile/qqapi.js?_bid=152")
}

export function setOnMqqShareHandler(params) {
  initMqq().then(() => {
    mqq.ui.setOnShareHandler(type => {
      params.type = type
      shareMessageInQQ(params)
    })
  })
}

export function getUrlImage(params, callback) {
  initMqq().then(() => {
    mqq.data.getUrlImage(params, callback)
  })
}

export function initWechatJSBridge() {
  return new Promise(resolve => {
    if (typeof WeixinJSBridge == "object" && typeof WeixinJSBridge.invoke == "function") {
      resolve()
    } else {
      if (document.addEventListener) {
        document.addEventListener("WeixinJSBridgeReady", resolve, false)
      } else if (document.attachEvent) {
        document.attachEvent("WeixinJSBridgeReady", resolve)
        document.attachEvent("onWeixinJSBridgeReady", resolve)
      }
    }
  })
}

export function setOnWechatShareHandler(params) {
  initWechatJSBridge().then(() => {
    WeixinJSBridge.on("menu:share:appmessage", shareMessageInWechat("sendAppMessage", params)) // 监听发送好友事件
    WeixinJSBridge.on("menu:share:timeline", shareMessageInWechat("shareTimeline", params)) // 监听朋友圈分享事件
    WeixinJSBridge.on("menu:share:qq", shareMessageInWechat("shareQQ", params)) // 监听分享到QQ事件
  })
}

function shareMessageInWechat(type, params) {
  return () => {
    WeixinJSBridge.invoke(
      type,
      {
        appid: params.wxAppid2,
        img_url: params.img,
        img_width: "240",
        img_height: "240",
        link:
          params.url ||
          `${location.origin}${location.pathname}${url.delParam(["pf", "code"], location.search)}&pf=${params.pf}${location.hash}?a=1`,
        desc: params.desc,
        title: params.title
      },
      () => {}
    )
    params.reportCallback && params.reportCallback()
  }
}

/**
 * 跳转手Q部分
 */

export function jumpToMqq(_url) {
  let url = "mqqapi://forward/url?src_type=web&version=1&url_prefix=" + btoa(_url)
  let userAgent = ua.getUserAgent()
  //判断微信6.5.6客户端，这个客户端不允许使用schema跳转跳手Q
  var m = / MicroMessenger\/([0-9\.]+)/i.exec(navigator.userAgent)
  if (m && m[1] && compare(m[1], "6.5.6") >= 0) {
    initWechatJSBridge().then(() => {
      onWxJSBridgeReady(url)
    })
  } else if (userAgent.QQ) {
    location.href = _url
  } else {
    location.href = url
  }
}

function onWxJSBridgeReady(url) {
  WeixinJSBridge.invoke(
    "launchApplication",
    {
      schemeUrl: url
    },
    function(res) {
      //如果没调起的话
      if (res.err_msg !== "launchApplication:ok") {
        if (/Android/.test(navigator.userAgent)) {
          location.href = url
        } else {
          WeixinJSBridge.invoke(
            "launchApplication",
            {
              appID: "mqqapi",
              parameter: url.replace(/^mqqapi:\/\//, "")
            },
            function() {}
          )
        }
      }
    }
  )
}

function compare(curV, reqV) {
  if (curV && reqV) {
    //将两个版本号拆成数字
    var arr1 = curV.split("."),
      arr2 = reqV.split(".")
    var minLength = Math.min(arr1.length, arr2.length),
      position = 0,
      diff = 0
    //依次比较版本号每一位大小，当对比得出结果后跳出循环（后文有简单介绍）
    while (position < minLength && (diff = parseInt(arr1[position]) - parseInt(arr2[position])) == 0) {
      position++
    }
    diff = diff != 0 ? diff : arr1.length - arr2.length
    //若curV大于reqV，则返回true
    return diff
  } else {
    //输入为空
    return -1
  }
}

export function generateScreenShots(id) {
  let shareContent = document.querySelector("#" + id) //需要截图的包裹的（原生的）DOM 对象
  let width = shareContent.offsetWidth //获取dom 宽度
  let height = shareContent.offsetHeight //获取dom 高度
  let canvas = document.createElement("canvas") //创建一个canvas节点
  let scale = 3 //定义任意放大倍数 支持小数
  canvas.width = width * scale //定义canvas 宽度 * 缩放
  canvas.height = height * scale //定义canvas高度 *缩放

  let content = canvas.getContext("2d") //获取context,设置scale
  content.scale(scale, scale)
  let rect = shareContent.getBoundingClientRect() //获取元素相对于视察的偏移量
  content.translate(-rect.left, -rect.top) //设置context位置，值为相对于视窗的偏移量负值，让图片复位
  let opts = {
    scale: scale, // 添加的scale 参数
    canvas: canvas, //自定义 canvas
    logging: true, //日志开关，便于查看html2canvas的内部执行流程
    width: width, //dom 原始宽度
    height: height,
    backgroundColor: null,
    useCORS: true // 【重要】开启跨域配置
  }

  return html2canvas(shareContent, opts).then(function(canvas) {
    let context = canvas.getContext("2d")
    // 【重要】关闭抗锯齿
    context.mozImageSmoothingEnabled = false
    context.webkitImageSmoothingEnabled = false
    context.msImageSmoothingEnabled = false
    context.imageSmoothingEnabled = false
    // console.log(canvas.toDataURL("image/jpeg"))

    let base64 = canvas.toDataURL("image/png")
    // self.dataURL = base64
    return base64
    // document.querySelector("#" + imgid).src = base64 // 【重要】默认转化的格式为png,也可设置为其他格式
  })
}

export function getOpenlink(params, extendParams) {
  return new Promise((resolve, reject) => {
    let env = helper.getCgiEnv(params.sandbox)
    let data = {
      offer_id: params.offerId,
      t: +new Date()
    }
    data = Object.assign(data, extendParams)

    request
      .ajax({
        url: `//${env}api.unipay.qq.com/v1/r/${params.offerId}/get_wx_openlink`,
        data: data
      })
      .then(res => {
        if (res.ret == 0) {
          resolve(res)
        } else {
          reject(res)
        }
      })
      .catch(reject)
  })
}

export function msdkShare({ desc, title, url, imgData, selected }) {
  let shareParams = {
    // title: config.SHARE_DETAIL.OPEN_TITLE,
    desc,
    title,
    url,
    imgData
  }

  if (selected === "weixin" || selected === "pengy") {
    shareParams.MsdkMethod = "WGSendToWeiXinWithUrl"
    shareParams.scene = selected === "weixin" ? "0" : "1"
    shareParams.mediaTagName = "MSG_INVITE"
  } else {
    if (selected == "qzone") {
      shareParams.scene = 1
    }
    if (selected == "qq") {
      shareParams.scene = 2
    }
    shareParams.MsdkMethod = "WGSendToQQ"
  }
  setTimeout(() => {
    if (window.msdkShare) {
      window.msdkShare(JSON.stringify(shareParams))
    }
  }, 100)
}

export function activity_query(params, extend) {
  return new Promise((resolve, reject) => {
    let env = helper.getCgiEnv(params.sandbox)
    let data = {
      t: +new Date(),
      pfkey: "pfkey",
      from_https: 1,
      from_h5: 1
    }

    data = Object.assign(data, extend, aes.encrypt(extend, ["openid", "openkey", "session_id", "session_type"], params.sandbox))
    request
      .ajax({
        url: `//${env}api.unipay.qq.com/v1/r/${params.offerId}/activity_query`,
        data: data
      })
      .then(res => {
        if (res.ret == 0) {
          resolve(res)
        } else {
          reject(res)
        }
      })
      .catch(reject)
  })
}

export function activity_op(params, extend) {
  return new Promise((resolve, reject) => {
    let env = helper.getCgiEnv(params.sandbox)
    let data = {
      t: +new Date(),
      pfkey: "pfkey",
      from_https: 1,
      from_h5: 1
    }

    data = Object.assign(data, extend, aes.encrypt(extend, ["openid", "openkey", "session_id", "session_type"], params.sandbox))
    request
      .ajax({
        url: `//${env}api.unipay.qq.com/v1/r/${params.offerId}/activity_op`,
        data: data
      })
      .then(res => {
        if (res.ret == 0) {
          resolve(res)
        } else {
          reject(res)
        }
      })
      .catch(reject)
  })
}

export function reward_pf_query(params, extend) {
  return new Promise((resolve, reject) => {
    let env = "pay"
    if (params.sandbox == "2") {
      env = "dev.api.unipay"
    } else if (params.sandbox == 1) {
      env = "sandbox.pay"
    }
    let data = {
      t: +new Date(),
      pfkey: "pfkey",
      from_https: 1,
      from_h5: 1
    }
    data = Object.assign(data, extend, aes.encrypt(extend, ["openid", "openkey", "session_id", "session_type"], params.sandbox))

    request
      .ajax({
        url: `//${env}.qq.com/cgi-bin/rewardpf/reward_pf_query.fcg`,
        data: data
      })
      .then(res => {
        if (res.ret == 0) {
          resolve(res)
        } else {
          reject(res)
        }
      })
      .catch(reject)
  })
}

export function cmallQueryIosWhitelist(params) {
  return new Promise((resolve, reject) => {
    let env = helper.getCgiEnv(params.sandbox)
    let urlParams = {
      cmd: "ios_whitelist",
      from_https: 1,
      from_h5: 1,
      pf: `mds_wechat_qb-__mds_aW9zd2hpdGVsaXN0_huodong_20230114-${params.clientVersion}`,
      pfkey: "pfkey",
      openid: params.openid,
      openkey: params.openkey,
      session_id: params.session_id,
      session_type: params.session_type,
      wx_appid: params.wx_appid
    }

    request
      .ajax({
        url: `//${env}api.unipay.qq.com/v1/r/${params.offerId}/cmall_query`,
        data: urlParams
      })
      .then(res => {
        if (res.ret == 0) {
          resolve(res)
        } else {
          reject(res)
        }
      })
      .catch(reject)
  })
}
